'use client'

import { Vanity } from 'components/Vanity/Vanity'
import { SiteSettings, VanityData } from 'config/types'
import { useStore } from 'stores/StoreProvider'
import { FC, useEffect, useRef } from 'react'

export const T1Content: FC<{ vanityData: VanityData }> = (props) => {
	const { vanityData } = props
	const loadSettings = useStore((state) => state.settings.loadSettings)
	const settingsRef = useRef<SiteSettings | null>(null)

	// This is pure garbage. The reason we need this is because "loadSettings" is a really bad function.
	// It's not pure, and it sets state in really weird ways.
	// So we need to memoize the settings here, but we also need to make sure that the settings
	// are available on the very first render (we can't use a state with useEffect because
	// the state is not available on the first render).

	// This is bad, but it's the only way I can think of to get the settings on the first render without rewriting the
	// loadSettings function to be pure.
	if (!settingsRef.current) {
		settingsRef.current = loadSettings(vanityData, true)
	}

	useEffect(() => {
		settingsRef.current = loadSettings(vanityData, true)
	}, [vanityData, loadSettings])

	// Ensure we never pass null to Vanity component
	if (!settingsRef.current) {
		return null
	}

	return <Vanity settings={settingsRef.current} />
}
